import React, { useState, useEffect } from 'react';
import { UserLink } from '../../Links/Links';
import { Desktop, Mobile } from '../../MediaQuery';
import { signup } from '../../../helpers/routes';

import { useUrlBuilder } from '../../../hooks/useUrlBuilder';

const AnonLinks = () => {
  const [loginUrl, setLoginUrl] = useState(`${signup}?tab=login`);
  const [registerUrl, setRegisterUrl] = useState(`${signup}?tab=login`);
  const { localized } = useUrlBuilder();

  useEffect(() => {
    setLoginUrl(
      `${signup}?tab=login&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`,
    );
    setRegisterUrl(
      `${signup}?tab=register&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`,
    );
  }, []);

  return (
    <>
      <UserLink primary href={localized(loginUrl)} data-cy="header-signin-link">
        Sign in <Desktop>/ Sign up</Desktop>
      </UserLink>

      <Mobile>
        <UserLink href={localized(registerUrl)} data-cy="header-register-link" border>
          Sign up
        </UserLink>
      </Mobile>
    </>
  );
};

export default AnonLinks;
